import React from "react";
import { Link } from "react-router-dom";
import "../../styles/BlogListSection.css";
import { FiUser } from "react-icons/fi";

const ArticleListItem = ({ post }) => {
  const avatar = post?.author?.avatar?.url || post?.author?.image || "/placeholder-avatar.png";
  const authorName =
    typeof post?.author === "string"
      ? post.author
      : `${post?.author?.firstName || ""} ${post?.author?.lastName || ""}`.trim();
  const category = post?.category?.name || post?.category || "";
  const date = post?.publishedDate
    ? new Date(post.publishedDate).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "";

     const truncateText = (text, maxLength = 120) => {
    if (!text) return "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  };

  return (
    <article className="bli-row" aria-labelledby={`bli-title-${post?.slug || post?._id}`}>
      <div className="bli-left text-secondary">
        <div
  className="bli-avatar bli-avatar-icon"
  role="img"
  aria-label={authorName || "Author profile"}
>
  <FiUser size={20} />
</div>

        <div className="bli-author ">
          <div className="bli-author-name text-secondary">{authorName}</div>
          <div className="bli-author-cat text-secondary">{category}</div>
        </div>
      </div>

      <div className="bli-center">
        <div className="bli-date text-secondary">{date}</div>
        <h3 id={`bli-title-${post?.slug || post?._id}`} className="bli-title">
          <Link
            to={`/blogs/${post?.slug}`}
            style={{ color: "inherit", textDecoration: "none" }}
            aria-label={`Read more about ${post?.title}`}
          >
            {post?.title}
          </Link>
        </h3>
         <p className="bli-excerpt text-secondary-muted">{truncateText(post?.description, 120)}</p>
        <div className="bli-stats text-secondary" aria-hidden>
  {post?.tags?.length > 0 && (
    <div className="bli-tags-container">
      {post.tags.map((t) => (
        <span key={t.tag || t} className="bli-tag-btn text-primary bg-secondary ">
          {t.tag || t}
        </span>
      ))}
    </div>
  )}
</div>          
        </div>


      <div className="bli-right">
        <Link to={`/blogs/${post?.slug}`} className="bli-cta btn-secondary" aria-label={`Read more about ${post?.title}`}>
          Read More ↗
        </Link>
      </div>
    </article>
  );
};

export default ArticleListItem;